import React, { useState, useEffect, useCallback } from 'react';
import { SortByProps, useSortBy } from '@usereactify/search';

export type ExampleSortByProps = React.ComponentProps<
    NonNullable<SortByProps["render"]>
>;

export const SortBy: React.FC<ExampleSortByProps> = (props) => {
    const showSortByOptionFirst = true;
    const [isShowingSortBy, setIsShowingSortBy] = useState(true);
    const sortByHook = useSortBy();

    const handleSelectChange = useCallback(
        (event: React.ChangeEvent<HTMLSelectElement>) => {
            sortByHook.setSortOption(event.target.value);
            setIsShowingSortBy(false);
            console.log('Selected sort option:', event.target.value);
        },
        [sortByHook]
    );

    return (
        <div className="rs__sortby">
            {showSortByOptionFirst && isShowingSortBy ? (
                <select
                    className="rs__sortby__select h5"
                    onChange={handleSelectChange}
                >
                    <option className="rs__sortby__option" value="">
                        Sort By
                    </option>
                    {props.sortOptions.map((sortOption) => (
                        <option
                            key={sortOption.handle}
                            className="rs__sortby__option"
                            value={sortOption.handle}
                        >
                            {sortOption.name}
                        </option>
                    ))}
                </select>
            ) : (
                <select
                    className="rs__sortby__select h5"
                    value={props.sortOption?.handle}
                    onChange={handleSelectChange}
                >

                    {props.sortOptions.map((sortOption) => (
                        <option
                            key={sortOption.handle}
                            className="rs__sortby__option"
                            value={sortOption.handle}
                        >
                            {sortOption.name}
                        </option>
                    ))}
                </select>
            )}
        </div>
    );
};
